import * as React from "react";
import { Component } from "react";
import "./message-bar.scss";
import EventBus, { Events } from "../../service/EventBus";
import ArrayUtil from "../../util/ArrayUtil";
import i18n from "i18next";

interface MessageEvent {
  level: string;
  text: string;
}

interface MessageBarProps {}

interface MessageBarState {
  messages: Array<MessageEvent>;
}

class MessageBar extends Component<MessageBarProps, MessageBarState> {
  subId: string;

  constructor(props: any) {
    super(props);

    this.state = {
      messages: [],
    };
  }

  componentDidMount() {
    this.subId = EventBus.subscribe(Events.msg, this.onMessage.bind(this));
  }

  componentWillUnmount() {
    EventBus.unsubscribe(this.subId);
  }

  onMessage(event: Event) {
    let msg: any = event.target;

    if (!msg) return;

    if (typeof msg === "function") {
      msg = msg();
    }

    let item: MessageEvent;

    if (typeof msg === "string") {
      item = { level: "info", text: msg };
    } else if (msg instanceof Error) {
      item = {
        level: "error",
        text: msg.message,
      };
    } else if (msg.response) {
      console.warn("Error response", msg.response);

      item = {
        level: "error",
        text: i18n.t("error.occurred"),
      };

      if (msg.response.data) {
        const data = msg.response.data;
        if (data.text) item.text = data.text;
      }
    } else {
      item = msg;
    }

    if (item && item.text) {
      this.state.messages.push(item);
      this.forceUpdate();

      setTimeout(() => this.remove(item), 10000);
    }
  }

  remove(item: MessageEvent) {
    if (ArrayUtil.remove(this.state.messages, (elt) => elt === item)) {
      this.forceUpdate();
    }
  }

  render() {
    return (
      <div className="message-bar" onClick={(evt) => this.setState({ messages: [] })}>
        {this.state.messages.map((msg, idx) => (
          <p key={idx} className={msg.level} dangerouslySetInnerHTML={{ __html: msg.text }} />
        ))}
      </div>
    );
  }
}

export default MessageBar;
